var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Домены:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4 col-lg-3" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.chooseDomains,
                expression: "chooseDomains"
              }
            ],
            staticClass: "oc-form__control store-fronts",
            attrs: { title: "Витрины" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.chooseDomains = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "general" } }, [
              _vm._v("Все домены (Общий шаблон)")
            ]),
            _vm._v(" "),
            _vm._l(_vm.domains, function(domain, index) {
              return _c(
                "option",
                {
                  key: index,
                  style: _vm.hasSettings(domain) ? "color: red" : "",
                  domProps: { value: domain }
                },
                [_vm._v(_vm._s(domain))]
              )
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "store-fronts" }, [
      _c("h2", { staticClass: "oc-settings__sub-header" }, [
        _vm._v("Яндекс Метрика:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Номер вашего счетчика:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-4 col-lg-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.yandex[_vm.chooseDomains].counter,
                expression: "settings.yandex[chooseDomains].counter"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[yandex][][counter]",
              placeholder: _vm.settings.yandex["general"].counter || 39266940
            },
            domProps: { value: _vm.settings.yandex[_vm.chooseDomains].counter },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.yandex[_vm.chooseDomains],
                  "counter",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Открыли форму:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-4 col-lg-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.yandex[_vm.chooseDomains].open,
                expression: "settings.yandex[chooseDomains].open"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[yandex][][open]",
              placeholder:
                _vm.settings.yandex["general"].open || "Идентификатор цели"
            },
            domProps: { value: _vm.settings.yandex[_vm.chooseDomains].open },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.yandex[_vm.chooseDomains],
                  "open",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Отправили форму:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-4 col-lg-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.yandex[_vm.chooseDomains].send,
                expression: "settings.yandex[chooseDomains].send"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[yandex][][send]",
              placeholder:
                _vm.settings.yandex["general"].send || "Идентификатор цели"
            },
            domProps: { value: _vm.settings.yandex[_vm.chooseDomains].send },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.yandex[_vm.chooseDomains],
                  "send",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Ошибка отправки:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-4 col-lg-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.yandex[_vm.chooseDomains].error,
                expression: "settings.yandex[chooseDomains].error"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[yandex][][error]",
              placeholder:
                _vm.settings.yandex["general"].error || "Идентификатор цели"
            },
            domProps: { value: _vm.settings.yandex[_vm.chooseDomains].error },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.yandex[_vm.chooseDomains],
                  "error",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Нажатие на плавающую кнопку:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-4 col-lg-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.settings.yandex[_vm.chooseDomains].smart_button_click,
                expression: "settings.yandex[chooseDomains].smart_button_click"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[yandex][][smart_button_click]",
              placeholder:
                _vm.settings.yandex["general"].smart_button_click ||
                "Идентификатор цели"
            },
            domProps: {
              value: _vm.settings.yandex[_vm.chooseDomains].smart_button_click
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.yandex[_vm.chooseDomains],
                  "smart_button_click",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Отправка заявки с плавающей кнопки:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-4 col-lg-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.yandex[_vm.chooseDomains].smart_button_send,
                expression: "settings.yandex[chooseDomains].smart_button_send"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[yandex][][smart_button_send]",
              placeholder:
                _vm.settings.yandex["general"].smart_button_send ||
                "Идентификатор цели"
            },
            domProps: {
              value: _vm.settings.yandex[_vm.chooseDomains].smart_button_send
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.yandex[_vm.chooseDomains],
                  "smart_button_send",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "oc-settings__sub-header" }, [
        _vm._v("Google Analytics:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Открыли форму:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.google[_vm.chooseDomains].open.category,
                expression: "settings.google[chooseDomains].open.category"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[google][][open][category]",
              placeholder:
                _vm.settings.google["general"].open.category || "Категория"
            },
            domProps: {
              value: _vm.settings.google[_vm.chooseDomains].open.category
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.google[_vm.chooseDomains].open,
                  "category",
                  $event.target.value
                )
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.google[_vm.chooseDomains].open.action,
                expression: "settings.google[chooseDomains].open.action"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[google][][open][action]",
              placeholder:
                _vm.settings.google["general"].open.action || "Действие"
            },
            domProps: {
              value: _vm.settings.google[_vm.chooseDomains].open.action
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.google[_vm.chooseDomains].open,
                  "action",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Отправили форму:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.google[_vm.chooseDomains].send.category,
                expression: "settings.google[chooseDomains].send.category"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[google][][send][category]",
              placeholder:
                _vm.settings.google["general"].send.category || "Категория"
            },
            domProps: {
              value: _vm.settings.google[_vm.chooseDomains].send.category
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.google[_vm.chooseDomains].send,
                  "category",
                  $event.target.value
                )
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.google[_vm.chooseDomains].send.action,
                expression: "settings.google[chooseDomains].send.action"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[google][][send][action]",
              placeholder:
                _vm.settings.google["general"].send.action || "Действие"
            },
            domProps: {
              value: _vm.settings.google[_vm.chooseDomains].send.action
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.google[_vm.chooseDomains].send,
                  "action",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Ошибка отправки:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.google[_vm.chooseDomains].error.category,
                expression: "settings.google[chooseDomains].error.category"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[google][][error][category]",
              placeholder:
                _vm.settings.google["general"].error.category || "Категория"
            },
            domProps: {
              value: _vm.settings.google[_vm.chooseDomains].error.category
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.google[_vm.chooseDomains].error,
                  "category",
                  $event.target.value
                )
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.google[_vm.chooseDomains].error.action,
                expression: "settings.google[chooseDomains].error.action"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[google][][error][action]",
              placeholder:
                _vm.settings.google["general"].error.action || "Действие"
            },
            domProps: {
              value: _vm.settings.google[_vm.chooseDomains].error.action
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.google[_vm.chooseDomains].error,
                  "action",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Нажатие на плавающую кнопку:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.settings.google[_vm.chooseDomains].smart_button_click
                    .category,
                expression:
                  "settings.google[chooseDomains].smart_button_click.category"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[google][][smart_button_click][category]",
              placeholder:
                _vm.settings.google["general"].smart_button_click.category ||
                "Категория"
            },
            domProps: {
              value:
                _vm.settings.google[_vm.chooseDomains].smart_button_click
                  .category
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.google[_vm.chooseDomains].smart_button_click,
                  "category",
                  $event.target.value
                )
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.settings.google[_vm.chooseDomains].smart_button_click
                    .action,
                expression:
                  "settings.google[chooseDomains].smart_button_click.action"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[google][][smart_button_click][action]",
              placeholder:
                _vm.settings.google["general"].smart_button_click.action ||
                "Действие"
            },
            domProps: {
              value:
                _vm.settings.google[_vm.chooseDomains].smart_button_click.action
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.google[_vm.chooseDomains].smart_button_click,
                  "action",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "col-xs-2 control-label" }, [
          _vm._v("Отправка заявки с плавающей кнопки:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.settings.google[_vm.chooseDomains].smart_button_send
                    .category,
                expression:
                  "settings.google[chooseDomains].smart_button_send.category"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[google][][smart_button_send][category]",
              placeholder:
                _vm.settings.google["general"].smart_button_send.category ||
                "Категория"
            },
            domProps: {
              value:
                _vm.settings.google[_vm.chooseDomains].smart_button_send
                  .category
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.google[_vm.chooseDomains].smart_button_send,
                  "category",
                  $event.target.value
                )
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.settings.google[_vm.chooseDomains].smart_button_send
                    .action,
                expression:
                  "settings.google[chooseDomains].smart_button_send.action"
              }
            ],
            staticClass: "oc-form__control",
            attrs: {
              type: "text",
              name: "settings[google][][smart_button_send][action]",
              placeholder:
                _vm.settings.google["general"].smart_button_send.action ||
                "Действие"
            },
            domProps: {
              value:
                _vm.settings.google[_vm.chooseDomains].smart_button_send.action
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.settings.google[_vm.chooseDomains].smart_button_send,
                  "action",
                  $event.target.value
                )
              }
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b733948", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b733948","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/analytics/Analytics.vue
// module id = 149
// module chunks = 0